const searchData = {
  tasks: {
    'Seed Account': {id: 'Seed Account', content: 'Seed Account'},
    'Seed': {id: 'Seed', content: 'Seed'},
    'First Name': {id: 'First Name', content: 'First Name'},
    'Client': {id: 'Client', content: 'Client'},
    'Last Name': {id: 'Last Name', content: 'Last Name'},
    'Phone': {id: 'Phone', content: 'Phone'},
    'Disposition Code': {id: 'Disposition Code', content: 'Disposition Code'},
    'Client Account Number': {id: 'Client Account Number', content: 'Client Account Number'},
    'Agency Number': {id: 'Agency Number', content: 'Agency Number'},
    'RP Phone': {id: 'RP Phone', content: 'RP Phone'},
    'POE Phone': {id: 'POE Phone', content: 'POE Phone'},
    'Balance': {id: 'Balance', content: 'Balance'},
    'Placement Date': {id: 'Placement Date', content: 'Placement Date'},
    'DOS': {id: 'DOS', content: 'DOS'},
    'Tag': {id: 'Tag', content: 'Tag'},
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'Default Search',
      taskIds: [
        'Seed Account',
        'First Name',
        'Client',
        'Last Name',
        'Phone',
        'Agency Number',
        'Disposition Code',
        'Client Account Number',
        'RP Phone',
        'POE Phone',
        'Seed',
        'Balance',
        'Placement Date',
        'DOS',
        'Tag',
      ],
    },
    'column-2': {
      id: 'column-2',
      title: 'Added Queries',
      taskIds: [],
    },
  },
  // Facilitate reordering of the columns
  columnOrder: ['column-1', 'column-2'],
};

export default searchData;
